import DisputesApi from '@/api/disputes.api'

const state = {
  /**
   * @type {Array}
   */
  disputes: []
}


/**
* @type {import('vuex').GetterTree<typeof state>}
*/
const getters = {
  formattedDisputes(state) {
    return state.disputes.map(item => {
      const callsAffected = item.callsAffected || []
      
      // Calculate total adjustment from callsAffected if available
      let totalAdjustment = 0
      if (callsAffected.length > 0) {
        totalAdjustment = callsAffected.reduce((sum, call) => {
          return sum + ((call.newPayoutAmount || 0) - (call.oldPayoutAmount || 0))
        }, 0)
      } else {
        // Fallback: use the dispute's own amount fields
        totalAdjustment = (item.newPayoutAmount || item.newConversionAmount || 0)
      }

      // Map status number to string if needed
      let statusText = item.status
      if (typeof item.status === 'number') {
        const statusMap = {
          0: 'Pending',
          1: 'Approved', 
          2: 'Rejected',
          3: 'PendingReview',
          4: 'Completed',
          5: 'PendingAdjustmentInRingba',
          6: 'PendingAdjustmentInX'
        }
        statusText = statusMap[item.status] || 'Unknown'
      }

      return {
        id: item.id,
        date: item.reviewedOn, 
        initiatedBy: item.initiatedBy ? item.initiatedBy.name : 'Unknown',
        reason: item.reason,
        callCount: item.callIds ? item.callIds.length : callsAffected.length,
        totalAmount: totalAdjustment,
        status: statusText,
        raw: item
      }
    })
  }
}


/**
* @type {import('vuex').ActionTree<typeof state>}
*/
const actions = {
  async fetchDisputes({ commit }, { dateFrom, dateTo }) {
    const response = await DisputesApi.getDisputes({
      dateFrom,
      dateTo
    })

    commit('SET_DISPUTES', response.data || [])

    return response
  },
}


/**
* @type {import('vuex').MutationTree<typeof state>}
*/
const mutations = {
  SET_DISPUTES(state, disputes) {
    state.disputes = disputes || []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


